import { handleDelete } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/handleDelete';
import { useDeleteRotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteRotationsplan/useDeleteRotationsplan';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { Button } from '@e2n/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function DeleteRotationsplanMobile({
  handleClose,
  rotationsplanId,
}: {
  handleClose: () => void;
  rotationsplanId: string;
}) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const [deleteRotationsplan] = useDeleteRotationsplan(standortIds);
  const navigate = useNavigate();

  async function handleConfirm() {
    handleDelete({
      deleteRotationsplan,
      navigate,
      rotationsplanId,
      t,
      setIsSubmitting,
    });
  }

  return (
    <div className="flex flex-col gap-2 items-center text-sm">
      <div className="font-semibold">
        {t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogTitle',
        )}
      </div>
      <div className="flex flex-col gap-5 ">
        <div className="flex flex-col gap-2 items-center">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogText',
          )}
          <div className="text-primary-red-500">
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.infoStandortwechsel',
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Button
            disabled={isSubmitting}
            variant="destructive"
            className="w-full"
            onClick={handleConfirm}>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.confirm',
            )}
          </Button>
          <Button variant="outline" className="w-full" onClick={handleClose}>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dismiss',
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
